var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-loader"},[_c('div',{staticClass:"text-primary"},[_c('font-awesome-icon',{attrs:{"icon":"spinner","spin":""}}),_vm._v(" "+_vm._s(_vm.dynamicMessage))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }